import React from 'react';

/**
 * Single stat card for the stat strip.
 * Props:
 *   - label: string (uppercase label shown above the number)
 *   - value: number | string (the big headline)
 *   - sublabel: optional string (small text below the number)
 *   - barColor: one of 'success' | 'warn' | 'danger' | 'muted' | 'accent'
 *   - valueTone: optional override for the number color; defaults to barColor
 */
const BAR = {
  success: 'border-l-steam-success',
  warn:    'border-l-steam-warn',
  danger:  'border-l-steam-danger',
  muted:   'border-l-surface-muted',
  accent:  'border-l-accent'
};
const TONE = {
  success: 'text-steam-success',
  warn:    'text-steam-warn',
  danger:  'text-steam-danger',
  muted:   'text-surface-text',
  accent:  'text-accent'
};

export default function StatCard({ label, value, sublabel, barColor = 'accent', valueTone }) {
  const bar = BAR[barColor] || BAR.accent;
  const tone = TONE[valueTone || barColor] || TONE.accent;
  return (
    <div className={`px-[14px] py-3 bg-surface-panel border border-surface-border border-l-[3px] ${bar}`}>
      <div className="text-[10px] font-bold uppercase tracking-[0.1em] text-surface-muted">{label}</div>
      <div className={`text-[22px] font-bold mt-1 ${tone}`}>{value}</div>
      {sublabel && <div className="text-[10px] text-surface-muted mt-0.5">{sublabel}</div>}
    </div>
  );
}
